import React from 'react';
import DynamicSidebar from './DynamicSidebar';
import './Sidebar.css';

const Sidebar = ({
  userRole,
  user,
  onNavigate,
  activeItem,
  onLogout,
  isCollapsed = false,
  expandedItems,
  onToggleExpanded,
  searchTerm
}) => {
  return (
    <aside className="bg-white border-r border-[#EEF2F7] transition-all duration-300 h-screen overflow-hidden w-full flex flex-col">
      <DynamicSidebar
        userRole={userRole}
        user={user}
        onNavigate={onNavigate}
        activeItem={activeItem}
        onLogout={onLogout}
        isCollapsed={isCollapsed}
        expandedItems={expandedItems}
        onToggleExpanded={onToggleExpanded}
        searchTerm={searchTerm}
      />
    </aside>
  );
};

export default Sidebar;
